@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/buttons.scss' as *;

// size, button-size, icon-size, border-radius
$size: 
  'sm' 16px 14px 3px,
  'md' 21px 18px 3px,
  'lg' 26px 18px 6px,
  'xl' 28px 18px 6px,
  'xxl' $button-height 18px 6px;

.IconButton {
  cursor: pointer;
  background: none;
  color: $color-grey-A;
  display: inline-block;
  line-height: 0;
  margin: 0;
  padding: 0;
  border: 0;

  &.isWhiteBackground {
    background: $theme-color-secondary-button-background;
    color: $theme-color-text;
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }

  &:active {
    background: $theme-color-secondary-button-active;
  }

  &:disabled {
    color: $color-grey-disabled;
    pointer-events: none;
    opacity: 0.3;
  }

  // Generate styles for each size
  @each $size,
    $button-size,
    $icon-size,
    $border-radius in $size {
    &.#{$size} {
      height: $button-size;
      width: $button-size;
      border-radius: $border-radius;

      svg {
        width: $icon-size;
        height: $icon-size;
      }
    }
  }

  &.border {
    border: 1px solid $theme-color-secondary-button-border;
  }
}
